<template>
  <v-row>
    <v-col cols="12">
      <div class=" layout">
        <v-card class="caja_titulo">
          <v-card-text>
            <h2>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="mr-2"
              >
                <path fill="none" d="M0 0h24v24H0V0z"></path>
                <path
                  d="M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.42zM8.48 16c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                  style="fill: white;"
                ></path>
              </svg>
              {{ $t("segundo.title_1") }}
            </h2>
          </v-card-text>
        </v-card>
      </div>
    </v-col>
    <v-col cols="12" offset-sm="2" sm="10">
      <div>
        <h4>{{ $t("segundo.pregunta_1") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_1"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_2") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_2"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_3") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_3"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_4") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_4"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_5") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_5"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_6") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_6"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_7") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_7"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <div>
        <h4>{{ $t("segundo.pregunta_8") }}</h4>
        <v-radio-group
          required
          :rules="[reglas.selectedRadio($t('segundo.item_faltante'))]"
          v-model="cuestionario_data.pregunta_8"
        >
          <v-radio :label="$t('segundo.si')" value="Si" />
          <v-radio :label="$t('segundo.no')" value="No" />
        </v-radio-group>
      </div>

      <v-expansion-panels class="mt-4">
        <v-expansion-panel>
          <v-expansion-panel-header class="green lighten-4">
            {{ $t("segundo.terminos") }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p v-for="(item, key) in 4" v-bind:key="key">
              {{ $t("segundo.text_terminos[" + key + "]") }}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-checkbox
        v-model="cuestionario_data.terminos"
        required
        :rules="[reglas.selectedRadio($t('segundo.acepta_falta'))]"
        :label="$t('segundo.acepta')"
      ></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Cuestionario",
  data: () => ({
    preguntas: 8,
  }),
  props: {
    cuestionario_data: {
      type: Object,
      default: () => {},
    },
    reglas: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style>
h4 {
  font-size: 19px;
  line-height: 1.375em;
  font-weight: 400;
  margin-top: 2rem;
}
.v-expansion-panel-content__wrap {
  padding-top: 1rem !important;
}
.v-expansion-panel-content__wrap p {
  font-size: 14px;
}
</style>
